import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUserTypeName } from "../../admin/navigation/adminNavigation";

/**
 * Leases live in the Lease module (the backend's Lease is title / budget / purpose / city / state, which is
 * what My Leases and the admin Lease page manage). The old tool form used fields the backend does not have,
 * so every Lease Management link lands on the working page for the signed-in role.
 */
const LeaseManagementTool = () => {
  const authState = useSelector((state) => state.auth);
  const role = String(getUserTypeName(authState) || "").toUpperCase();
  const target = role === "PARTNER" ? "/partner/leases" : role === "CUSTOMER" ? "/customer/leases" : "/lease";
  return <Navigate to={target} replace />;
};

export default LeaseManagementTool;
